var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAtividadeColetiva = function SvgAtividadeColetiva(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 16C31.5 24.5604 24.5604 31.5 16 31.5C7.43959 31.5 0.5 24.5604 0.5 16C0.5 7.43959 7.43959 0.5 16 0.5C24.5604 0.5 31.5 7.43959 31.5 16Z",
    fill: "url(#paint0_linear_716_4014)",
    stroke: "#BEBFCB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 22C28.001 18.6667 26.6677 17 24 17H22C23.3333 17.9454 24 19.2787 24 21C24 23 23.6719 24 23.0158 24H26C27.3333 24 28 23.3333 28 22Z",
    fill: "#003A79"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26 12.5C26 11.1194 24.8806 10 23.5 10C22.1194 10 21 11.1194 21 12.5C21 13.8806 22.1194 15 23.5 15C24.8806 15 26 13.8806 26 12.5Z",
    fill: "#003A79"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 17C21.6677 17 23.001 18.6667 23 22C23 23.3333 22.3333 24 21 24H11C9.66667 24 9 23.3333 9 22C9 18.6667 10.3346 17 13.0037 17H19ZM16 7C18.209 7 20 8.791 20 11C20 13.209 18.209 15 16 15C13.791 15 12 13.209 12 11C12 8.791 13.791 7 16 7Z",
    fill: "#498FFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 22C3.99898 18.6667 5.33231 17 8 17H10C8.66667 17.9454 8 19.2787 8 21C8 23 8.32807 24 8.9842 24H6C4.66667 24 4 23.3333 4 22Z",
    fill: "#003A79"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12.5C6 11.1194 7.11938 10 8.5 10C9.88062 10 11 11.1194 11 12.5C11 13.8806 9.88062 15 8.5 15C7.11938 15 6 13.8806 6 12.5Z",
    fill: "#003A79"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0014 19C17.5034 19 18.7513 18.1418 19 17.0131C19 17.0003 13 16.9992 13 17.0003C13.2421 18.1353 14.4937 19 16.0014 19Z",
    fill: "#003A79"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_716_4014",
    x1: 26.0685,
    y1: 32,
    x2: 26.0685,
    y2: 11.863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F5"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAtividadeColetiva, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/atividade-coletiva.9b202726.svg";
export { ForwardRef as ReactComponent };